import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthFacade } from '@piqet-angular/data';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-activate-user',
  templateUrl: './activate-user.component.html',
  styleUrls: ['./activate-user.component.scss'],
})
export class ActivateUserComponent {
  UID: string | null = null;
  constructor(
    public authFacade: AuthFacade,
    private route: ActivatedRoute,
    private router: Router,
    private _authService: AuthenticationService,
    private _toasterService: ToastrService
  ) {}

  ngOnInit(): void {
    const { activationCode, UID, trialCode } = this.route.snapshot.queryParams;

    const isValid = (value: any): boolean =>
      value !== null && value !== undefined && value.toString().trim() !== '';

    if (isValid(activationCode)) {
      this.authFacade.activeUser(activationCode.trim());
    } else if (isValid(UID)) {
      this.authFacade.activeUserByUID(UID.trim());
    } else if (isValid(trialCode)) {
      // This block handles email verification specifically for trial users
      this.authFacade.activeUserByTrialCode(trialCode.trim());
    } else {
      this.router.navigate(['/login']);
    }
  }
}
